<template>
  <Modal v-model="iossModal" :title="iossTitle" width="500"
    :transfer="false" :mask-closable="false" @on-visible-change="iossChange">
    <Form ref="iossForm" :model="iossForm" :rules="ruleValidate" :label-width="labelWidth" @submit.native.prevent>
      <Row style="width: 80%">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1005520')" prop="name">
            <Input clearable v-model.trim="iossForm.name"/>
            <span class="font-size-12">{{ $t('key1005446') }}</span>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1005521')" prop="code">
            <Input clearable v-model.trim="iossForm.code"/>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="iossModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="iossBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "iossModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      iossModal: false,
      iossTitle: '',
      iossForm: {
        code: '',
        name: ''
      },
      ruleValidate: {
        name: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005516'), trigger: 'blur'}
        ],
        code: [
          {required: true, validator: v.validateIoss(), trigger: 'blur'}
        ]
      },
      iossType: 'add',
    };
  },
  created() {

  },
  methods: {
    // 初始化数据
    initIossData(type, data) {
      this.iossType = type;
      let obj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005471'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005517')
      };
      this.iossTitle = obj[type];
      if (type === 'edit') {
        this.ymsIossId = data.ymsIossId;
        for (let key in this.iossForm) {
          this.iossForm[key] = data[key];
        }
      }
      this.iossModal = true;
    },
    // 保存
    iossBtn() {
      let v = this;
      let url = '';
      let method = '';
      let text = '';
      let query = Object.assign({}, v.iossForm);
      if (v.iossType === 'add') {
        url = api.post_ymsIoss_insert;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000194');
      } else if (v.iossType === 'edit') {
        url = api.ymsIoss_update;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279');
        query.ymsIossId = v.ymsIossId;
      }
      v.$refs['iossForm'].validate((valid) => {
        if (valid) {
          v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.iossModal = false;
              v.$Message.success(text);
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    iossChange(val) {
      if (!val) {
        this.$refs['iossForm'].resetFields();
      }
    },
    // 校验IOSS编号
    validateIoss() {
      let v = this;
      let isIoss = v.$regular.isIoss;
      return function (rule, value, callback) {
        if (!value) {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005518')));
        } else if (!isIoss.test(value)) {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005519')));
        }
        callback();
      };
    }
  }
};
</script>

<style lang="less" scoped>

</style>